import { render, staticRenderFns } from "./DetourComponent.vue?vue&type=template&id=87d01faa&"
import script from "./DetourComponent.vue?vue&type=script&lang=js&"
export * from "./DetourComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetourComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports